import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0px",
    width: "100%",
  },
  heading: {
    fontSize: "20px !important",
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const FormAccordion = ({
  disabled,
  title,
  headerId,
  children,
  dirty,
  onChange,
  ...props
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (_, isExpanded) => {
    if (disabled) {
      setExpanded(false);
    }

    setExpanded(isExpanded);
    onChange?.call(null, isExpanded);
  };

  useEffect(() => {
    (disabled || !dirty) && setExpanded(false);
  }, [disabled, dirty]);

  return (
    <Accordion
      {...props}
      elevation={disabled ? 0 : 4}
      onChange={handleChange}
      disabled={disabled}
      expanded={expanded}
      defaultExpanded={false}
    >
      <AccordionSummary
        aria-controls="panel1a-content"
        expandIcon={<ExpandMoreIcon />}
        id={headerId}
      >
        <Typography className={useStyles().heading}>{title}</Typography>
      </AccordionSummary>

      <AccordionDetails classes={{ root: useStyles().root }}>
        <fieldset className="w-100">{children}</fieldset>
      </AccordionDetails>
    </Accordion>
  );
};

export default FormAccordion;
